// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormLabel,
//   Grid,
//   IconButton,
//   MenuItem,
//   InputLabel,
//   Select,
//   FormControl,
// } from "@mui/material";
import { Add, Delete, Close } from "@mui/icons-material";
import provinces from "../../provinces.json";
import { Toaster } from "react-hot-toast";
import CAR_TYPES from "./../../utils/variable";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";


const PersonalInfoForm = ({
  readCard,
  readCardDriver,
  formData,
  handleChange,
  customerGroups,
  group,
  setGroup,
  personType,
  setPersonType,
  cars,
  drivers,
  handleAddCar,
  handleAddDriver,
  handleDeleteCar,
  handleDeleteDriver,
  handleCarChange,
  handleDriverChange,
}) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-800">ข้อมูลลูกค้า</h3>
        <button
          onClick={readCard}
          className="text-white bg-[#10B981] hover:bg-[#059669] font-medium rounded-lg text-sm px-4 py-2 transition-colors shadow-sm"
        >
          ดึงข้อมูลบัตรประชาชน
        </button>
      </div>

      <div className="grid grid-cols-12 gap-6">
        {/* Profile Image */}
        <div className="col-span-12 md:col-span-3 flex justify-center items-start">
          <div className="w-48 h-48 bg-gray-100 rounded-xl border-2 border-dashed border-gray-300 flex items-center justify-center overflow-hidden relative">
             {formData?.img ? (
                <img
                  src={formData.img}
                  alt="Profile"
                  className="w-full h-full object-cover"
                />
             ) : (
                <div className="text-gray-400 flex flex-col items-center">
                   <ImageNotSupportedIcon style={{ fontSize: 60 }} />
                   <span className="text-xs mt-2">ไม่มีรูปภาพ</span>
                </div>
             )}
          </div>
        </div>

        {/* Form Fields */}
        <div className="col-span-12 md:col-span-9 space-y-4">
          
          {/* Person Type Radio */}
          <div className="flex items-center space-x-6">
             <label className="text-sm font-medium text-gray-700">ประเภทบุคคล</label>
             <div className="flex items-center space-x-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                   <input
                      type="radio"
                      name="personType"
                      value="normal"
                      checked={personType === "normal"}
                      onChange={(e) => setPersonType(e.target.value)}
                      className="w-4 h-4 text-green-600 focus:ring-green-500 border-gray-300"
                   />
                   <span className="text-sm text-gray-900">บุคคลธรรมดา</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer">
                   <input
                      type="radio"
                      name="personType"
                      value="corporate"
                      checked={personType === "corporate"}
                      onChange={(e) => setPersonType(e.target.value)}
                      className="w-4 h-4 text-green-600 focus:ring-green-500 border-gray-300"
                   />
                   <span className="text-sm text-gray-900">นิติบุคคล</span>
                </label>
             </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1">
                 <label className="text-sm font-medium text-gray-700">ชื่อ-นามสกุล <span className="text-red-500">*</span></label>
                 <input
                    type="text"
                    value={formData.name || ""}
                    onChange={handleChange("name")}
                    className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all"
                    placeholder=""
                 />
              </div>
              {personType !== "corporate" && (
                <div className="space-y-1">
                   <label className="text-sm font-medium text-gray-700">วันเดือนปีเกิด</label>
                   <input
                      type="date"
                      value={formData.dob || ""}
                      onChange={handleChange("dob")}
                      className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all"
                   />
                </div>
              )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div className="space-y-1">
                 <label className="text-sm font-medium text-gray-700">
                    {personType !== "corporate" ? "เลขบัตรประชาชน" : "เลขประจำตัวผู้เสียภาษี"}
                 </label>
                 <input
                    type="text"
                    value={formData.citizenId || ""}
                    onChange={handleChange("citizenId")}
                    className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all"
                 />
             </div>
             <div className="space-y-1">
                 <label className="text-sm font-medium text-gray-700">เบอร์โทรศัพท์</label>
                 <input
                    type="text"
                    value={formData.phone || ""}
                    onChange={handleChange("phone")}
                    className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all"
                 />
             </div>
          </div>

          <div className="space-y-1">
             <label className="text-sm font-medium text-gray-700">กลุ่มสมาชิก</label>
             <div className="relative">
                <select
                   value={group}
                   onChange={(e) => setGroup(e.target.value)}
                   className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all appearance-none"
                >
                   <option value="">เลือกกลุ่ม...</option>
                   {customerGroups.map((item) => (
                      <option key={item.id} value={item.id}>{item.name}</option>
                   ))}
                </select>
                {/* Custom arrow could be added here, currently relying on browser default or appearance-none */}
                {group && (
                  <button
                    onClick={() => setGroup("")}
                    className="absolute right-8 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <Close fontSize="small" />
                  </button>
                )}
             </div>
          </div>
        </div>
        
        {/* Address Row (Full Width) */}
        <div className="col-span-12 space-y-1">
             <label className="text-sm font-medium text-gray-700">ที่อยู่</label>
             <textarea // Changed to textarea for address typically
                rows={2}
                value={formData.address || ""}
                onChange={handleChange("address")}
                className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all"
             />
        </div>
      </div>
      
      <hr className="border-gray-100 my-6" />

      {/* Cars Section */}
      <div className="space-y-4">
         <h4 className="text-md font-semibold text-gray-800 flex items-center gap-2">
            ข้อมูลยานพาหนะ
         </h4>
         {cars.map((car, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-4 border border-gray-100 flex flex-col md:flex-row gap-4 items-end relative group">
                <div className="flex-1 w-full space-y-1">
                   <label className="text-xs font-medium text-gray-500">ประเภทรถ</label>
                   <select
                      value={car.type}
                      onChange={(e) => handleCarChange(index, "type", e.target.value)}
                      className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                   >
                      <option value="">เลือกประเภท...</option>
                      {CAR_TYPES.map((t) => (
                         <option key={t} value={t}>{t}</option>
                      ))}
                   </select>
                </div>
                <div className="flex-1 w-full space-y-1">
                   <label className="text-xs font-medium text-gray-500">ทะเบียนรถ</label>
                   <input
                      type="text"
                      value={car.license}
                      onChange={(e) => handleCarChange(index, "license", e.target.value)}
                      className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                   />
                </div>
                <div className="flex-1 w-full space-y-1">
                   <label className="text-xs font-medium text-gray-500">จังหวัด</label>
                   <select
                      value={car.province}
                      onChange={(e) => handleCarChange(index, "province", e.target.value)}
                      className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                   >
                      <option value="">เลือกจังหวัด...</option>
                      {provinces.map((name) => (
                         <option key={name} value={name}>{name}</option>
                      ))}
                   </select>
                </div>
                <button
                   onClick={() => handleDeleteCar(index)}
                   className="p-2.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                >
                   <Delete fontSize="small" />
                </button>
            </div>
         ))}
         <button
            onClick={handleAddCar}
            className="flex items-center gap-2 text-green-600 hover:text-green-700 font-medium text-sm px-4 py-2 rounded-lg hover:bg-green-50 transition-colors border border-dashed border-green-200 hover:border-green-300 w-full justify-center"
         >
            <Add fontSize="small" />
            เพิ่มรถยนต์
         </button>
      </div>

      <hr className="border-gray-100 my-6" />

      {/* Drivers Section */}
      <div className="space-y-4">
         <h4 className="text-md font-semibold text-gray-800 flex items-center gap-2">
            ข้อมูลคนขับรถ / ผู้ขาย
         </h4>
         {drivers.map((driver, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-4 border border-gray-100 relative">
               <div className="absolute top-2 right-2">
                   <button
                       onClick={() => handleDeleteDriver(index)}
                       className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    >
                       <Delete fontSize="small" />
                    </button>
               </div>
               
               <div className="flex flex-col md:flex-row gap-6">
                  {/* Driver Image */}
                  <div className="w-full md:w-auto flex justify-center">
                     <div className="w-32 h-32 bg-gray-200 rounded-lg flex items-center justify-center overflow-hidden border border-gray-300 relative">
                        {driver?.img ? (
                           <img src={driver.img} alt="Driver" className="w-full h-full object-cover" />
                        ) : (
                           <ImageNotSupportedIcon className="text-gray-400" />
                        )}
                     </div>
                  </div>

                  {/* Driver Inputs */}
                  <div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      {/* Name Row */}
                      <div className="md:col-span-2 lg:col-span-2 space-y-1">
                          <label className="text-xs font-medium text-gray-500">ชื่อ</label>
                          <div className="flex gap-2">
                             <button
                                onClick={() => readCardDriver(index)}
                                className="px-3 py-1 bg-blue-50 text-blue-600 text-xs rounded-lg hover:bg-blue-100 border border-blue-100 whitespace-nowrap"
                             >
                                อ่านบัตร
                             </button>
                             <input
                                type="text"
                                value={driver.name}
                                onChange={(e) => handleDriverChange(index, "name", e.target.value)}
                                className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                             />
                          </div>
                      </div>
                      <div className="md:col-span-2 lg:col-span-2 space-y-1">
                          <label className="text-xs font-medium text-gray-500">นามสกุล</label>
                          <input
                                type="text"
                                value={driver.surname}
                                onChange={(e) => handleDriverChange(index, "surname", e.target.value)}
                                className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                          />
                      </div>
                      
                      <div className="space-y-1">
                          <label className="text-xs font-medium text-gray-500">เลขบัตรประชาชน</label>
                          <input
                                type="text"
                                value={driver.idCard}
                                onChange={(e) => handleDriverChange(index, "idCard", e.target.value)}
                                className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                          />
                      </div>
                      <div className="space-y-1">
                          <label className="text-xs font-medium text-gray-500">เบอร์โทรศัพท์</label>
                          <input
                                type="text"
                                value={driver.phone}
                                onChange={(e) => handleDriverChange(index, "phone", e.target.value)}
                                className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                          />
                      </div>
                      <div className="space-y-1">
                          <label className="text-xs font-medium text-gray-500">วันเกิน</label>
                          <input
                                type="date"
                                value={driver.birthday}
                                onChange={(e) => handleDriverChange(index, "birthday", e.target.value)}
                                className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                          />
                      </div>
                      <div className="space-y-1">
                          <label className="text-xs font-medium text-gray-500">บัตรหมดอายุ</label>
                          <input
                                type="date"
                                value={driver.expire}
                                onChange={(e) => handleDriverChange(index, "expire", e.target.value)}
                                className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                          />
                      </div>
                  </div>
               </div>
            </div>
         ))}
         <button
            onClick={handleAddDriver}
            className="flex items-center gap-2 text-green-600 hover:text-green-700 font-medium text-sm px-4 py-2 rounded-lg hover:bg-green-50 transition-colors border border-dashed border-green-200 hover:border-green-300 w-full justify-center"
         >
            <Add fontSize="small" />
            เพิ่มคนขับรถ / ผู้ขาย
         </button>
      </div>

    </div>
  );
};

export default PersonalInfoForm;
